import React from 'react';
import { Grid, Typography } from '@mui/material';
import { useTranslate } from 'react-admin';

const EmptyState = ({ title, message, isError }) => {
  const translate = useTranslate();
  return (
    <div style={{ flex: 1 }}>
      <Grid container spacing={0} style={{ background: '#FFF', padding: 30 }}>
        <Grid item xs={12} style={{ borderBottom: '1px solid #AAA', marginBottom: 20 }}>
          <Typography variant="h4" gutterBottom>
            {title ? title : translate('report.title', { _: 'Satış Raporu' })}
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <Typography variant="h6" gutterBottom>
            {isError
              ? translate('ra.notification.item_does_not_exist', { _: 'Hata' })
              : translate('ra.action.show', { _: 'Bilgi' })}
          </Typography>
          <Typography variant="body1" gutterBottom>
            {message}
          </Typography>
        </Grid>
      </Grid>
    </div>
  );
};

export default EmptyState;
